import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "text-base font-medium leading-6 text-(--colors-text-heading) dark:text-white" };
const _hoisted_2 = { class: "space-y-5" };
const _hoisted_3 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-4" };
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { Button, Modal } from "@eudonet/opal";
import { useProfileStore } from "@/modules/settings/public";
import { formatDateTime } from "@/shared/utils/date-formatting";
import PropertyRow from "@/shared/components/PropertyRow.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'UserPropertiesModal',
    props: {
        modelValue: { type: Boolean },
        properties: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { t, locale } = useI18n();
        const profileStore = useProfileStore();
        const isOpen = computed({
            get: () => props.modelValue,
            set: (value) => emit("update:modelValue", value),
        });
        // Null passes straight through to PropertyRow, which owns the "unknown" placeholder
        // (common.placeholder) — writing our own would diverge from the contact modal.
        const formattedCreatedAt = computed(() => {
            const value = props.properties?.createdAt;
            if (!value)
                return null;
            return formatDateTime(value, locale.value, profileStore.profile?.dateFormat, profileStore.profile?.timeFormat, profileStore.profile?.timeZone ?? undefined);
        });
        function close() {
            emit("update:modelValue", false);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Modal), {
                modelValue: isOpen.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((isOpen).value = $event)),
                size: "md",
                "header-position": "left",
                "footer-position": "right",
                "data-testid": "user-properties-modal"
            }, {
                header: _withCtx(() => [
                    _createElementVNode("h3", _hoisted_1, _toDisplayString(_unref(t)("accessManager.users.properties.title")), 1 /* TEXT */)
                ]),
                footer: _withCtx(() => [
                    _createVNode(_unref(Button), {
                        variant: "secondary",
                        label: _unref(t)('accessManager.users.properties.close'),
                        "data-testid": "user-properties-modal-close",
                        onClick: close
                    }, null, 8 /* PROPS */, ["label"])
                ]),
                default: _withCtx(() => [
                    _createElementVNode("dl", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createVNode(PropertyRow, {
                                label: _unref(t)('accessManager.users.properties.createdAt'),
                                value: formattedCreatedAt.value,
                                variant: "shell"
                            }, null, 8 /* PROPS */, ["label", "value"])
                        ])
                    ])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"]));
        };
    }
});
